<div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <div class="icon-container">
          <i class="fa fa-user-plus" aria-hidden="true"></i>
        </div>
        <div class="header-text">
          <h2 style="font-weight: 600">Add Connections</h2>
          <p>Send a request to start the digital relationship.</p>
        </div>
      </div>
        <img class="close-button" (click)="onCancel()" src="assets/images/close-circle.svg" alt="Upload">
    </div>
  
    <div class="dialog-content">
      <form [formGroup]="searchForm">
        <!-- Category Selection -->
        <div class="category-section">
          <h3 class="selchoose">Category</h3>
          <!-- <mat-form-field appearance="outline">
            <mat-label> </mat-label>
            <mat-select formControlName="categories" multiple (selectionChange)="onCategoryChange($event)"> 
              <mat-option *ngFor="let category of data.categories" [value]="category.id">
                {{category.title}}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
          <mat-form-field class="example-full-width" appearance="outline">
            <input class="matIn" matInput [value]="selectedCategoryTitle" disabled>
          </mat-form-field>

        </div>
  
        <!-- Search Section -->
        <div class="search-section">
          <h3 class="selchoose">Select Connection</h3>
          <div class="search-container">
            <i class="material-icons">search</i>
            <input matInput 
                   formControlName="searchQuery"
                   placeholder="Search for connection..."
                   (input)="onSearch()">
          </div>
        </div>
  
        <!-- Connection List -->
        <div class="connection-list">
          <!-- Add your connection list items here -->
          <div class="relationship-list" *ngFor="let item of filteredList">
            <i class="fa fa-user" aria-hidden="true"></i>
            <div class="name">
                <p>{{capitalizeFirstLetter(item.firstName)}}  {{capitalizeFirstLetter(item.lastName)}}</p> 
                <!-- <p class="eemail">{{item.email}}</p>  -->
            </div>
            <button (click)="openSendRequestDialog(item)" >Send Request</button>
        </div>

        </div>
      </form>
    </div>
</div>
